import { FormInstance } from "antd";

const removeExtraSpace = (fieldName: string, form: FormInstance) => (event: any) => {
  const { value } = event.target;
  form.setFieldsValue({ [fieldName]: value.replace(/\s+/g, " ").trim() });
};

export const addTwoDecimal = (fieldName: string, form: FormInstance, event: any) => {
  const value = event.target.value.split(".")[1];

  if (isNaN(event.target.value)) {
    return form.setFieldValue(fieldName, Number(0).toFixed(2));
  }

  if (!value || value.length < 2) {
    form.setFieldValue(fieldName, Number(event.target.value).toFixed(2));
  }
  if (value && value.length > 2) {
    form.setFieldValue(fieldName, parseFloat(event.target.value).toFixed(2));
  }
};
export default removeExtraSpace;
